var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("CargoMsg.Cargo_ConfigPagePart"),
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c("div", { staticClass: "page-part-config" }, [
        _c("div", { staticClass: "config-section" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfigName")))
          ]),
          _c(
            "div",
            { staticClass: "name-inputs" },
            _vm._l(_vm.languageConfigs, function(lang) {
              return _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentLang === lang.code,
                    expression: "currentLang === lang.code"
                  }
                ],
                key: lang.code,
                staticClass: "name-input",
                attrs: {
                  value:
                    _vm.tempInputValues[lang.code] ||
                    (
                      _vm.localConfig.languageList.find(function(l) {
                        return l.language === lang.code
                      }) || {}
                    ).name,
                  placeholder: lang.placeholder
                },
                on: {
                  input: function(val) {
                    return _vm.updateLanguageName(lang.code, val)
                  }
                }
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "lang-selector" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.currentLang,
                    callback: function($$v) {
                      _vm.currentLang = $$v
                    },
                    expression: "currentLang"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "zh_CN" } }, [
                    _vm._v(_vm._s(_vm.getLangName("zh_CN")))
                  ]),
                  _c("el-radio-button", { attrs: { label: "en_US" } }, [
                    _vm._v(_vm._s(_vm.getLangName("en_US")))
                  ]),
                  _c("el-radio-button", { attrs: { label: "ja_JP" } }, [
                    _vm._v(_vm._s(_vm.getLangName("ja_JP")))
                  ]),
                  _c("el-radio-button", { attrs: { label: "ru_RU" } }, [
                    _vm._v(_vm._s(_vm.getLangName("ru_RU")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "config-section" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PagePartFunction")))
          ]),
          _c(
            "div",
            { staticClass: "function-selector" },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("CargoMsg.Cargo_PleaseSelectFunction")
                  },
                  on: { change: _vm.handleBlockTypeChange },
                  model: {
                    value: _vm.localConfig.blockType,
                    callback: function($$v) {
                      _vm.$set(_vm.localConfig, "blockType", $$v)
                    },
                    expression: "localConfig.blockType"
                  }
                },
                _vm._l(_vm.finalPagePartTypes, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              ),
              _vm.isUploadFile
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success", size: "mini" },
                      on: { click: _vm.addUploadItem }
                    },
                    [_vm._v("+")]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm.isBusinessElements
          ? _c("div", { staticClass: "config-section" }, [
              _c(
                "div",
                { staticClass: "config-item" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.localConfig.businessConfig.isReadonly,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.localConfig.businessConfig,
                            "isReadonly",
                            $$v
                          )
                        },
                        expression: "localConfig.businessConfig.isReadonly"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_ReadOnly")) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.isCsnInfo
          ? _c("div", { staticClass: "config-section" }, [
              _c(
                "div",
                { staticClass: "config-item" },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.localConfig.csnConfig.isReadonly,
                        callback: function($$v) {
                          _vm.$set(_vm.localConfig.csnConfig, "isReadonly", $$v)
                        },
                        expression: "localConfig.csnConfig.isReadonly"
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_ReadOnly")) + " "
                      )
                    ]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "config-item" }, [
                _c(
                  "div",
                  { staticClass: "field-display-options" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.localConfig.csnConfig.needConsignee,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.csnConfig,
                              "needConsignee",
                              $$v
                            )
                          },
                          expression: "localConfig.csnConfig.needConsignee"
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CargoMsg.Cargo_Consignee")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.localConfig.csnConfig.needShipper,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.csnConfig,
                              "needShipper",
                              $$v
                            )
                          },
                          expression: "localConfig.csnConfig.needShipper"
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CargoMsg.Cargo_Shipper")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.localConfig.csnConfig.needNotify,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.csnConfig,
                              "needNotify",
                              $$v
                            )
                          },
                          expression: "localConfig.csnConfig.needNotify"
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CargoMsg.Cargo_Notify")) + " "
                        )
                      ]
                    ),
                    _vm.isCsnInfoAlsoNotify
                      ? _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.localConfig.csnConfig.needAlsoNotify,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.localConfig.csnConfig,
                                  "needAlsoNotify",
                                  $$v
                                )
                              },
                              expression: "localConfig.csnConfig.needAlsoNotify"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_AlsoNotify")) +
                                " "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.isCsnInfoAgentParty
                      ? _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.localConfig.csnConfig.needAgentParty,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.localConfig.csnConfig,
                                  "needAgentParty",
                                  $$v
                                )
                              },
                              expression: "localConfig.csnConfig.needAgentParty"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("CargoMsg.Cargo_AgentParty")) +
                                " "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        false
          ? _c(
              "div",
              { staticClass: "config-section" },
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      model: _vm.localConfig.uploadConfig,
                      "label-width": "120px"
                    }
                  },
                  _vm._l(_vm.localConfig.uploadConfig.items, function(
                    item,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: index, staticClass: "upload-item" },
                      [
                        _c(
                          "div",
                          { staticClass: "upload-item-header" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "CargoMsg.Cargo_OperationInstructions"
                                  )
                                }
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: item.instruction,
                                    callback: function($$v) {
                                      _vm.$set(item, "instruction", $$v)
                                    },
                                    expression: "item.instruction"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeUploadItem(index)
                                  }
                                }
                              },
                              [_vm._v("-")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_InstructionParameter"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: item.parameter,
                                callback: function($$v) {
                                  _vm.$set(item, "parameter", $$v)
                                },
                                expression: "item.parameter"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e(),
        _vm.localConfig.blockType === _vm.PAGE_PART_TYPE.CONTAINER_INFO.value
          ? _c("div", { staticClass: "config-section" }, [
              _c("div", { staticClass: "config-item" }, [
                _c(
                  "div",
                  { staticClass: "field-display-options" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.localConfig.containerConfig.isReadonly,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.containerConfig,
                              "isReadonly",
                              $$v
                            )
                          },
                          expression: "localConfig.containerConfig.isReadonly"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReadOnly")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.containerConfig
                              .showContainerCargoInfo,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.containerConfig,
                              "showContainerCargoInfo",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.containerConfig.showContainerCargoInfo"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SystemMaintenance.DisplayCargoPackingInformation"
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "config-item" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("SystemMaintenance.ControlPropertyConfiguration")
                    )
                  )
                ])
              ]),
              _c("div", { staticClass: "config-item" }, [
                _c(
                  "div",
                  {
                    staticClass: "field-display-options",
                    staticStyle: { "padding-left": "15px" }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        attrs: { disabled: "" },
                        model: {
                          value:
                            _vm.localConfig.containerConfig
                              .showMasterContainerModeIfMaster,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.containerConfig,
                              "showMasterContainerModeIfMaster",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.containerConfig.showMasterContainerModeIfMaster"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "SystemMaintenance.WhenMainTicketDisplayMode"
                            )
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.containerConfig
                              .showUpdatePortDataButton,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.containerConfig,
                              "showUpdatePortDataButton",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.containerConfig.showUpdatePortDataButton"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("SystemMaintenance.UpdatePortDataButton")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm.localConfig.blockType === _vm.PAGE_PART_TYPE.AE_CARGO_INFO.value
          ? _c("div", { staticClass: "config-section" }, [
              _c("div", { staticClass: "config-item" }, [
                _c(
                  "div",
                  { staticClass: "field-display-options" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.localConfig.aeCargoInfoConfig.isReadonly,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "isReadonly",
                              $$v
                            )
                          },
                          expression: "localConfig.aeCargoInfoConfig.isReadonly"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReadOnly")))]
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "config-item" }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("AirExport.ControlDisplayConfiguration"))
                  )
                ])
              ]),
              _c("div", { staticClass: "config-item" }, [
                _c(
                  "div",
                  {
                    staticClass: "field-display-options",
                    staticStyle: { "padding-left": "15px" }
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.aeCargoInfoConfig.goodsInfoContract,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "goodsInfoContract",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.aeCargoInfoConfig.goodsInfoContract"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("AirExport.WovenFabricorder")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.aeCargoInfoConfig.goodsInfoBooking,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "goodsInfoBooking",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.aeCargoInfoConfig.goodsInfoBooking"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AirExport.BookingForCargobooking"))
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.aeCargoInfoConfig.goodsInfoActual,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "goodsInfoActual",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.aeCargoInfoConfig.goodsInfoActual"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("AirExport.ItemMaoTiForwardWarehouseActual")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.aeCargoInfoConfig.quantityStation,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "quantityStation",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.aeCargoInfoConfig.quantityStation"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Terminal")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.aeCargoInfoConfig.quantitySigning,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "quantitySigning",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.aeCargoInfoConfig.quantitySigning"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SignContract")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value:
                            _vm.localConfig.aeCargoInfoConfig.goodsInfoDocument,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.localConfig.aeCargoInfoConfig,
                              "goodsInfoDocument",
                              $$v
                            )
                          },
                          expression:
                            "localConfig.aeCargoInfoConfig.goodsInfoDocument"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("AirExport.ItemMaoTiOrderProcessing"))
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }